import { ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
import { buttonVariants } from '@/components/ui/button';
import { StaggerChildren, StaggerItem } from '@/components/motion';
import { cn } from '@/lib/utils/cn';
import { quickStartSteps } from '../data/quick-start-steps';

export function QuickStartGuide() {
  return (
    <StaggerChildren className="relative pl-8 sm:pl-10">
      {/* Vertical connecting line */}
      <div className="absolute left-[15px] top-4 bottom-4 w-0.5 bg-border sm:left-[19px]" />

      {quickStartSteps.map((step, index) => {
        const isLast = index === quickStartSteps.length - 1;
        return (
          <StaggerItem key={step.number}>
            <div className={cn('relative pb-8', isLast && 'pb-0')}>
              {/* Number circle */}
              <div className="absolute -left-8 sm:-left-10 flex h-8 w-8 items-center justify-center rounded-full border-2 border-primary bg-background text-sm font-bold text-primary sm:h-10 sm:w-10 sm:text-base">
                {step.number}
              </div>

              {/* Content card */}
              <div className="rounded-lg border bg-card p-4 sm:p-5 transition-shadow hover:shadow-sm">
                <h3 className="text-base font-semibold sm:text-lg">{step.title}</h3>
                <p className="mt-1 text-sm text-muted-foreground">{step.description}</p>

                {/* Detail bullets */}
                <ul className="mt-3 space-y-1.5">
                  {step.details.map((detail, dIdx) => (
                    <li key={dIdx} className="flex items-start gap-2 text-sm text-muted-foreground">
                      <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-primary/50" />
                      <span>{detail}</span>
                    </li>
                  ))}
                </ul>

                {/* Link button */}
                {step.link && (
                  <div className="mt-4">
                    <Link
                      to={step.link}
                      className={cn(buttonVariants({ variant: 'outline', size: 'sm' }), 'gap-1')}
                    >
                      Ir a {step.title.split(' ').slice(0, 2).join(' ')}
                      <ExternalLink className="h-3.5 w-3.5" />
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </StaggerItem>
        );
      })}
    </StaggerChildren>
  );
}
